import { MUELLIF_KULLANICI_LISTESI } from "../constants/requestUrls";

import { getRequest } from "../request";

const MuellifKullaniciListesi = (muellifBuroId) => {
  return getRequest({ url: MUELLIF_KULLANICI_LISTESI + "?muellifBuroId=" + muellifBuroId });
}

export default MuellifKullaniciListesi;